export default {
  async index(ctx) {
    if (ctx.method !== 'GET') return (ctx.status = 404);
    ctx.body = '';
  },
};
